export const styles = (theme) => ({
  
  table: {
    position: "relative",
    margin: "auto",
    width: "100%",
    border: "1px solid rgba(0,0,0,0.1)",
  },
  tableModified: {
    overflow: "auto",
  },
  exportIcon: {
    float: "right",
    color: "green",
    cursor: "pointer",
    fontSize: "24px",
    marginTop: "0.3rem",
    marginRight: "24px",
  },
  exportIconbtnAppl: {
    float: "right",
    color: "green",
    cursor: "pointer",
    fontSize: "24px",
    marginTop: "0.5rem",
    marginRight: "24px",
  },
  excelIcon: {
    fontSize: "1.6rem",
    float: "right",
    color: "green",
    cursor: "pointer",
    padding: "12px",
    // marginTop: "12px",
  },

  csvIcon: {
    fontSize: "1.6rem",
    float: "right",
    color: "#3a94d0",
    cursor: "pointer",
    padding: "12px",
    // marginTop: "2px",
  },

  pdfIcon: {
    fontSize: "24px",
    float: "right",
    color: "red",
    cursor: "pointer",
    padding: "12px",
  },
  wfExportClose: {
    width: "10px",
    height: "10px",
    marginRight: "10px",
    float: "right",
  },
  tableWrapper: {
    display: "inline-block",
    [theme.breakpoints.down("sm")]: {
      overflowX: "auto",
      display: "grid",
    },
    width: "60%",
    marginLeft:"4rem"
  },
  tableWrapper1:{
    display: "inline-block",
    [theme.breakpoints.down("sm")]: {
      overflowX: "auto",
      display: "grid",
    },
    width: "60%",
    
  },
  exportDisplay: {
    display: "contents",
  },

  thead: {
    height: "30px",
    background: "#dfe2ee",
    color: "#fff",
    // fontWeight:"800 ! important"
  },
  theadprospect: {
    backgroundColor: "#dfe2ee",
    fontWeight: "600",
    fontSize: ".9em",
  },
  theaddashboard:{
    backgroundColor: "#02c1c6 !important",
    fontWeight: "300",
    fontSize: ".9em",
    color: "#fff !important"
  },
  selectedrow: {
    height: "18px !important",
    backgroundColor: "#b3cccc !important",
    cursor: "pointer !important",
    "&:hover": {
      backgroundColor: "#f2f2f2",
      color: "white",
    },
  },
  export: {
    paddingLeft: "16%",
    marginLeft: "3px",
  },

  placing: {
    [theme.breakpoints.only("lg")]: {
      top: "27% !important",
    },
  },
  headRow: {
    height: "30px",
    borderBottom:"0px"
  },

  footer: {
    marginBottom: "0px",
    marginTop: "0px",
    height: "42px",
    minHeight: "32px",
    background: "#dfe2ee",
    color: "black",
    borderBottomLeftRadius: "5px",
    borderBottomRightRadius: "5px",
    overflowX:"hidden !important",
    padding: "0px 40px 0px 5px !important"
  },
  footerprospect: {
    marginBottom: "0px",
    marginTop: "0px",
    height: "42px",
    minHeight: "32px",
    backgroundColor: "#dfe2ee",
    color: "black",
    borderBottomLeftRadius: "5px",
    borderBottomRightRadius: "5px",
    overflowX:"hidden !important",
  },
  headerRow: {
    color: "blue",
    paddingRight: 4,
    paddingLeft: 30,
  },
  tbody: {
    background: "ghostwhite",
  },

  row: {
    height: "18px",
    "&:hover": {
      backgroundColor: "#f2f2f2",
      color: "white",
      cursor: "pointer",
    },
  },
  validationMessage: {
    color: "red !important",
    fontSize: "12px !important",
    marginLeft: "0px",
  },
  row5: {
    height: "18px",
    "&:hover": {
      backgroundColor: "#f2f2f2",
      color: "white",
    },
  },
  headerCell: {
    color: "black",
    paddingRight: 4,
    paddingLeft: 5,
    height: "30px",
    background: "#cce6ff",
    fontWeight: "600 ! important",
  },
  headerCell1: {
    color: "black",
    paddingRight: 4,
    paddingLeft: 5,
    height: "30px",
    background: "#cce6ff",
    fontWeight: "600 ! important",
    textAlign: "left",
  },
  headerCell2: {
    color: "black",
    paddingRight: 4,
    paddingLeft: 5,
    height: "30px",
    background: "#cce6ff",
    fontWeight: "600 ! important",
    padding: "1px !important",
  },

  pagination: {
    color: "white",
    padding: "0px",
  },

  floatRight: {
    float: "right",
    padding: "10px",
  },
  search: {
    [theme.breakpoints.down("sm")]: {
      marginLeft: "2px",
    },
    [theme.breakpoints.down("md")]: {
      fontSize:"10px !important"
    },
  },
  
  button: {
    marginTop: "1px",
    marginRight: "4px",
    marginBottom: "8px",
    marginLeft: " 5px",
    [theme.breakpoints.down("sm")]: {
      fontSize: "8px",
      width: "80px",
    },
  },
  button2: {
    color: "#fff",
    backgroundColor: "#0089cf",
    borderColor: "#0089cf",
    "&:hover": {
      color: "#fff",
      backgroundColor: "#243a6f",
      borderColor: "#243a6f",
    },
  },
  pagination1: {
    width: "100%",
    textAlign: "right",
    float: "right",
  },
  tableCell1: {
    width: "100%",
    borderBottom: "0px",
    display: "inline-flex",
    [theme.breakpoints.down("xs")]: {
      minWidth: "490px",
      display: "table-caption",
    },
  },
  tableCell: {
    paddingRight: 4,
    paddingLeft: 10,
    height: "19px",
    borderBottom: "0px"
    // padding:"0px"
  },
  mbrAddress1: {
    paddingRight: 4,
    paddingLeft: 5,
    height: "19px",
    wordBreak: "break-word",
  },

  tableCellHeader: {
    paddingRight: 4,
    paddingLeft: 5,
    background: "#053674",
    color: "white",
    height: "34px",
  },

  tableCellEligCheck: {
    paddingRight: 30,
    paddingLeft: 5,
  },
  headingCell: {
    paddingRight: 4,
    paddingLeft: 5,
    fontWeight: "500",
  },

  svgicon: {
    opacity: 0.0,
  },
  lepHeader: {
    fontSize: "0.9rem",
    textAlign: "center",
  },
  mobileWidth: {
    width: "70% !important",
    padding: "0px !important",
    maxHeight: "75vh !important",
    overflowY: "auto !important",

    [theme.breakpoints.down("xs")]: {
      marginTop: "70px !important",
      width: "150% !important",
      maxHeight: "100vh !important",
      overflowY: "auto !important",
      shrink: "true !important",
    },
  },
  attestation1: {
    color: "rgba(39, 108, 155, 1)",
    paddingTop: "30px",
    paddingLeft: "3px",
  },

  confirmDialogButton: {
    margin: theme.spacing.unit,
    backgroundColor: "#2e88e2",
    color: "white",
    "&:hover": {
      backgroundColor: "#2e88e2",
    },
  },

  confirmDialog: {
    border: "1px none black",
    borderRadius: "8px",
    backgroundColor: "white !important",
    padding: "30px",
    boxShadow: "0 10px 6px -6px #777",
    [theme.breakpoints.down("md")]: {
      padding: "15px",
    },
  },
  paddingSearch: {
    padding: "4px",
  },
  print: {
    float: "right",
  },
  marginExport: {
    marginLeft: "5px",
  },
  appliedAmtTableCell: {
    textAlign: "right",
    paddingRight: 48,
    paddingLeft: 5,
    height: "19px",
    width: "140px",
  },
  lepSummaryTableCell: {
    paddingRight: 4,
    paddingLeft: 5,
    height: "19px",
    textAlign: "left",
  },
  infoIcon: {
    marginLeft: "2px",
    color: "darkblue",
    cursor: "pointer",
    fontSize: "18px",
  },
  displayIcon: {
    display: "flex",
  },
  displayIcon2: {
    display: "flex",
    minWidth: "95px",
  },
});

export const actionsStyles = (theme) => ({
  root: {
    flexShrink: 0,
    color: theme.palette.text.secondary,
    marginLeft: theme.spacing.unit * 2.5,
  },
  iconButton: {
    padding: "5px",
    color: "black",
  },
});
